import { render } from "./FormChatComponent.vue?vue&type=template&id=87ea7ed4&scoped=true&ts=true"
import script from "./FormChatComponent.vue?vue&type=script&lang=ts"
export * from "./FormChatComponent.vue?vue&type=script&lang=ts"

import "./FormChatComponent.vue?vue&type=style&index=0&id=87ea7ed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ea7ed4"]])

export default __exports__